import { COLLECTION_DETAILS_STATUSES_MAP, CollectionDetailsStatus } from '../VehicleCollectionSubjects';

export const POST_SALE_PAGES_ALLOWED_STATUSES = {
  SOLD_DOCUMENTS_REVIEWED: 'sold_documents_reviewed',
  SOLD_INVOICE_PAID: 'sold_invoice_paid',
  SOLD_INVOICE_RAISED: 'sold_invoice_raised',
} as const;

export type VehicleCollectionPageAllowedStatuses =
  (typeof POST_SALE_PAGES_ALLOWED_STATUSES)[keyof typeof POST_SALE_PAGES_ALLOWED_STATUSES];

export const STATUSES_FOR_DISPLAY_SCHEDULED_COLLECTION_DATE: CollectionDetailsStatus[] = [
  COLLECTION_DETAILS_STATUSES_MAP.SCHEDULED_COLLECTION_DATE_CONFIRMED,
  COLLECTION_DETAILS_STATUSES_MAP.COLLECTION_DAY,
  COLLECTION_DETAILS_STATUSES_MAP.INSPECTION_STARTED,
  COLLECTION_DETAILS_STATUSES_MAP.INSPECTION_COMPLETED,
  COLLECTION_DETAILS_STATUSES_MAP.COLLECTION_COMPLETED,
  COLLECTION_DETAILS_STATUSES_MAP.COLLECTION_RESCHEDULED,
];

export const STATUS_FOR_DISPLAY_COLLECTION_DATE_CONTENT: CollectionDetailsStatus[] = [
  COLLECTION_DETAILS_STATUSES_MAP.SCHEDULED_COLLECTION_DATE_CONFIRMED,
  COLLECTION_DETAILS_STATUSES_MAP.INSPECTION_STARTED,
  COLLECTION_DETAILS_STATUSES_MAP.INSPECTION_COMPLETED,
  COLLECTION_DETAILS_STATUSES_MAP.COLLECTION_RESCHEDULED,
];
